package com.nonopn.skywatcher.common.app.pages.map.model.weather

import kotlinx.serialization.Serializable

@Serializable
data class WeatherReport(
    val weatherCoded: String,
    val uvi: Int,
    val aqi: Int?,
    val temperature: FloatHolder,
    val rainProbability: IntHolder,
    val rainLevel: FloatHolder,
    val humidity: IntHolder,
    val pressure: DoubleHolder,
    val windSpeed: FloatHolder,
    val windGust: FloatHolder,
    val windDirection: IntHolder,
    val airQualityPollutants: List<AirQualityPollutant>
) {
    val actualUVIndex: UVIndex
        get() {
            val found = UVIndex.entries.firstOrNull { it.threshold >= uvi }

            return found ?: UVIndex.Low
        }

    val actualAQI: AQI?
        get() {
            if (null == aqi) return null

            val found = AQI.entries.firstOrNull { it.threshold > aqi }

            return found ?: AQI.Hazardous
        }

    companion object {
        fun fake() = WeatherReport(
            weatherCoded = "1",
            uvi = 1,
            aqi = 1,
            temperature = FloatHolder(1.0f, 1.0f),
            rainProbability = IntHolder(1, 1),
            rainLevel = FloatHolder(0f,0f),
            humidity = IntHolder(1, 1),
            pressure = DoubleHolder(1.0, 1.0),
            windSpeed = FloatHolder(1.0f, 1.0f),
            windGust = FloatHolder(1.0f, 1.0f),
            windDirection = IntHolder(1, 1),
            airQualityPollutants = emptyList()
        )
    }
}

@Serializable
data class DoubleHolder(
    val now: Double,
    val later: Double
)

@Serializable
data class IntHolder(
    val now: Int,
    val later: Int
)

@Serializable
data class FloatHolder(
    val now: Float,
    val later: Float
)
